// extracted by mini-css-extract-plugin
export default {"Container":"Map_Container__b7MFh","CompanyMap":"Map_CompanyMap__yLPhl","Companylane":"Map_Companylane__xtr-6","title":"Map_title__FO9FT"};